import axios from "axios";
// import { toast } from 'react-toastify';

// Configure axios defaults
axios.defaults.withCredentials = true; // Enable sending cookies with requests
axios.defaults.headers.common['Content-Type'] = 'application/json';

// Add request interceptor to include auth token from cookies or localStorage
axios.interceptors.request.use(
  (config) => {
    // Backend uses cookies, but we can also check localStorage for token
    // Cookies are sent automatically with withCredentials: true
    const token = localStorage.getItem("token");
    const cookieToken = document.cookie.split(';').find(c => c.trim().startsWith('token='));
    
    // Log request for debugging
    console.log('🔵 [HTTP_REQUEST]', config.method?.toUpperCase(), config.url, {
      hasLocalStorageToken: !!token,
      hasCookieToken: !!cookieToken,
      withCredentials: config.withCredentials,
      dataSize: config.data ? (typeof config.data === 'object' ? JSON.stringify(config.data).length : String(config.data).length) : 0
    });
    
    // If we have a token in localStorage, add it as Bearer token (some APIs might use this)
    if (token && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    console.error('❌ [HTTP_REQUEST] Request error:', error);
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling and logging
axios.interceptors.response.use(
  (response) => {
    // Log successful responses for debugging
    console.log('✅ [HTTP_RESPONSE]', response.config.method?.toUpperCase(), response.config.url, {
      status: response.status,
      data: response.data ? (typeof response.data === 'object' ? JSON.stringify(response.data).substring(0, 200) : response.data) : 'no data'
    });
    return response;
  },
  (error) => {
    // Handle errors safely - check if error.response exists
    console.error('❌ [HTTP_RESPONSE] Error:', {
      url: error.config?.url,
      method: error.config?.method,
      status: error.response?.status,
      message: error.response?.data?.message || error.message,
      data: error.response?.data
    });
    
    if (error.response) {
        const expectedError = 
            error.response.status >= 400 &&
            error.response.status < 500;

        if(expectedError){
            // Client error (4xx) - can be handled silently or with toast
            console.error('❌ [HTTP_RESPONSE] Client error:', error.response.status, error.response.data);
        }
    } else if (error.request) {
        // Network error - request made but no response
        console.error('❌ [HTTP_RESPONSE] Network error:', error.request);
    } else {
        // Something else happened
        console.error('❌ [HTTP_RESPONSE] Error:', error.message);
    }

    return Promise.reject(error);
  }
);

const httpService = {
    get: axios.get,
    put: axios.put,
    post: axios.post,
    delete: axios.delete
};

export default httpService;